import {mapMutations, mapGetters} from 'vuex';

export default {
    computed: {
        ...mapGetters({
            roles: 'player-profile/roles'
        }),
    },
    methods: {
        ...mapMutations({
            setModal: 'player-profile/setModal',
            toggleModal: 'player-profile/toggleModal'
        }),
        openModal() {
            this.setModalAttributes();
        },
        setModalAttributes() {
            if (this.modal) {
                this.setModal(this.modal);
            }
            this.toggleModal(this.modalTarget);
        }
    }
}